<app-bandeau-page [breadcrumb]="infoBandeau.breadcrumb" [linkBandeau]="infoBandeau.image" [titreBandeau]="infoBandeau.titre" ></app-bandeau-page>
<app-donation-onglet></app-donation-onglet>
<section class="sanitaire__section pb-5">
  <div class="container-fuid g-0">
    <div class="row row-sanitaire bg-gray d-flex justify-content-xl-start justify-content-center pb-5">
      <h2 class="page-title">Pôle Rééducation / Réadaptation</h2>
      <div class="col-xxl-5 col-xl-5 col-md-8 d-flex justify-content-end">
        <img class="bg-grey col-11" src="./../../assets/service-soins.jpg">
      </div>
      <div class="col-xxl-4 col-xl-5 col-md-10 col-11">
        <div class="title-with-pill mb-4">
          <span class="pill-title"></span>
          <h2 class="texte">Service de Soins Médicaux et de Réadaptation</h2>
        </div>
        <p>Trois programmes sont proposés :</p>
        <div class="div-soin d-flex flex-column">
          <a [routerLink]="['/pole-sanitaire/programme-restauration']">Programme de Restauration Fonctionnelle du Rachis (RFR) <i class="fas fa-arrow-right"></i></a>
          <a [routerLink]="['/pole-sanitaire/programme-musculo-squelettiques']">Programme Troubles Musculo-Squelettiques (TMS) <i class="fas fa-arrow-right"></i></a>
          <a [routerLink]="['/pole-sanitaire/programme-readaptation']">Programme de Réhabilitation Professionnelle <i class="fas fa-arrow-right"></i></a>
        </div>
      </div>
    </div>
  </div>
  <div class="row row-page d-flex justify-content-center mt-5">
    <div class="col-xxl-4 col-xl-5 col-md-10 col-11">
      <div class="title-with-pill mb-4">
        <span class="pill-title"></span>
        <h2 class="texte">Service de Réadaptation professionnelle</h2>
      </div>
      <p>Le <strong>Service de  Réadaptation Professionnelle</strong> est un établissement médico-social agréé par l’ARS Bretagne pour 40 places, avec une possibilité d’hébergement. Il accueille des personnes reconnues «Travailleur Handicapé» inscrites dans une démarche de reprise d’activité professionnelle compatible avec leur santé et propose un accompagnement global à la réalisation de leur projet.</p>
      <div class="d-flex justify-content-end">
        <a class="btn btn-grey" [routerLink]="['/pole-medico-social/service-readaptation-professionnelle']">En savoir plus</a>
      </div>
    </div>
    <div class="col-xxl-6 col-xl-5 col-md-10 d-flex justify-content-start">
      <img class="bg-grey col-11" src="./../../assets/SRP.jpg">
    </div>
  </div>
</section>
